import React, { Component } from 'react';
import { Flex, Link, Button } from "../../components";
import vars from "../../vars";
import styled from 'styled-components';
import ChartistGraph from 'react-chartist';
import 'chartist-plugin-axistitle';
import Chartist from 'chartist';

const QuestionsOverview = styled.div`
  display: grid;
  grid-template-columns: repeat(5, ${({ gridSize }) => gridSize ? gridSize + 'px' : '60px'});
  grid-gap: 0.7em 0;
  margin: 10px;
  justify-items: center;
  text-align: center;
  
`;
const Hex = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300" >
    <polygon points="300,150 225,280 75,280 0,150 75,20 225,20" />
  </svg>
);
// const Badge = () => (
//   <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 300 300" >
//     <polygon points="25 40 50 25 50 75 25 90 0 75 0 25" />
//   </svg>
// );
const Badge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 500 300" >
    <polygon points="124,65 142,65 142,364 71,323 71,65 71,323 5,364 5,65" fill='none' stroke="black" stroke-width='1' />
  </svg>
);

const Hexagon = styled(Flex)`
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 3em;
    height: 3em;
    cursor: pointer;
    text-decoration: none;
    span {
      color: #000;
      z-index: 1;
    }
  }

  svg {
    position: absolute;
    fill: white;
    width: 100%;
    height: 100%;
    polygon {
      stroke: #d6d4d4;
      stroke-width: 10px;
      transition: all 0.3s esae;
      border: 1px solid black;
    }
    transition: all 0.3s esae;
    // border: 1px solid black;
  }
`;

const BadgeDiv = styled.div`
width: 30%;
svg {
    position: absolute;
    top: 60px;
    left: 68%;
    fill: none;
    width: 100%;
    polygon {
      stroke: black;
      stroke-width: 1px;
      transition: all 0.3s esae;
      border: 1px solid black;
    }
    transition: all 0.3s esae;
    // border: 1px solid black;
  }

`

const StyledHeadings = styled.h4`
    text-align: center;
    font-size: 16px;
    font-weight: 900;
    color: black; 
    margin: auto;
    padding-left: 10px;
`
const PerformanceReport = styled.div`
  text-align: center;
  border: 1px transparent;
  border-radius: 8px;
  padding: 20px 10px;
  background-color: #f6f6f6e3;
  margin: 20px;
  align-items: center;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
  margin-top: 5px;
  `
const ReportHeading = styled.h4`
  text-align: center; 
  font-size: 16px;
  font-weight: 900;
  color: black;
  margin: auto;
  padding-left: 10px;
  padding-bottom: 10px;
`

const SecondaryHeading = styled.p`
  text-align: center;
  font-size: 14px;
  color: #827e7e;
  margin-bottom: 25px;
`

class TestSummary extends Component {


  componentDidMount = () => {
    let questions = this.props.response.time_per_question;
    let percentageCorrect = [];
    let count = 0;
    let labelsArray = [];
    questions.map((question) => {
      percentageCorrect.push(question.percentage_correct)
      count = count + 1;
      labelsArray.push(count)
    })

    let data = {
      series: [percentageCorrect],
      labels: labelsArray
    }
    var options = {
      seriesBarDistance: 5,
      horizontalBars: false,
      height: 230,
      chartPadding: {
        right: 10,
        bottom: 10,
        left: 30,
      },

      axisX: {
        axisTitle: "Questions",
        tickLength: 20,
        gridThickness: 1,
        scaleMinSpace: 10,
        low: 0,

      },

      axisY: {
        offset: 30,
        type: Chartist.FixedScaleAxis,
        low: 0,
        position: 'start',
        scaleMinSpace: 10,
        high: 100,
        ticks: [0, 20, 40, 60, 80, 100],

      },
      plugins: [
        Chartist.plugins.ctAxisTitle({
          axisX: {
            axisTitle: 'Questions',
            axisClass: 'ct-axis-title',
            offset: {
              x: 0,
              y: 35
            },
            textAnchor: 'middle'
          },
          axisY: {
            axisTitle: '% of students answered correctly',
            axisClass: 'ct-axis-title',
            offset: {
              x: 0,
              y: 15
            },
            textAnchor: 'middle',
            flipTitle: true
          }
        })
      ],
    };

    let chart = new Chartist.Bar('#ct-chart', data, options);
    chart.on('draw', function (data) {
      if (data.type === 'grid' && data.index !== 0) {
        data.element.remove();
      }
      if (data.type === 'bar') {
        data.element.attr({
          style: `stroke: green`
        })
      }
    });
  }

  getTime(time) {
    let min = Math.floor(time / 60);
    let sec = time - min * 60;
    if (min >= 1) {
      return min + " min " + (sec > 0 ? (sec + " sec") : '')
    } else {
      return sec + " sec"
    }
  }

  render() {
    let { response, tid, answers, questions, sections_dict } = this.props;
    let correct = response.correct_answered_count
    let total = response.total_questions_count
    let unanswered = response.unanswered_count
    let wrong = response.wrong_answered_count
    const sqSize = 140;
    const strokeWidth = 28;
    const radius = (sqSize - strokeWidth) / 2;
    const viewBox = `0 0 ${sqSize} ${sqSize}`;
    const dashArray = radius * Math.PI * 2;
    let obt_marks = 0, total_marks = 0;
    let windowSize = window.innerWidth;
    let boxWidth = (windowSize - 40) / 3;
    let time_taken = response.total_time;
    let minutes = Math.floor(time_taken / 60);
    let seconds = time_taken - (minutes * 60)
    if (time_taken <= 9) {
      time_taken = '0' + time_taken
    }
    if (minutes <= 9) {
      minutes = '0' + minutes
    }
    if (seconds <= 9) {
      seconds = '0' + seconds
    }
    let timeTaken = time_taken < 60 ? '00:' + time_taken + ` min` : minutes + `:` + seconds + ` min`;
    let chartWidth = response.total_questions_count <= 13 ? '100%' : response.total_questions_count <= 18 ? '120%' : '150%';
    let rank = response.rank.split('/')[0]
    let sections = response.sections;
    console.log(sections)
    let score = response.percentage
    const dashOffset = dashArray - dashArray * score / 100;
    let Description = score > 85 ? 'Congratulations on your outstanding performance' : score < 85 && score > 70 ? 'Something here ' : 'Congratulations on your performance.';
    return (
      <div>
        {/* <div>this is overall test summary </div> */}
        <div className='rankDiv'>
          <div style={{ width: '70%' }}>
            <img width='60%' height='60%' src='/images/award.svg' />
          </div>
          <div className='rank'>
            <div className='rankValue'>{rank}</div>
            <div className='rankText'>Rank</div>
          </div>
        </div>
        <div className={score > 50 ? 'confettiDiv' : ''}>

          <PerformanceReport size={score > 50 ? true : false}>
            <div className='wronganswerconfetti'></div>
            <ReportHeading>PERFORMANCE REPORT</ReportHeading>
            {/* <p style={{ textAlign: 'left', fontSize: '16px', paddingLeft:'12px' }}>Here we will write some text to appreciate student performance in the test</p> */}
            <div className='boxes'>
              <Flex direction='row' justifyCenter alignCenter justifyAround style={{ margin: score > 50 ? '0' : '0', marginTop: '20px' }}>

                <div className='box correct'>
                  <ul className='list'>
                    <li className='listHeading'>{correct}</li>
                    <li className='listValue'>Correct</li>
                  </ul>
                </div>
                <div className='box incorrect'>
                  <ul className='list'>
                    <li className='listHeading'>{wrong}</li>
                    <li className='listValue'>Incorrect</li>
                  </ul>
                </div>
                <div className='box unanswered'>
                  <ul className='list'>
                    <li className='listHeading'>{unanswered}</li>
                    <li className='listValue'>Unanswered</li>
                  </ul>
                </div>
              </Flex>
            </div>
            <svg
              width={`${sqSize}`}
              height={`${sqSize}`}
              viewBox={viewBox}>
              <defs>
                <linearGradient id="myGradient" gradientTransform="rotate(0)">
                  <stop offset="0%" stop-color="#8896de" />
                  <stop offset="100%" stop-color="#3F51B5" />
                </linearGradient>
              </defs>
              <circle
                className="circle-background"
                cx={sqSize / 2}
                cy={sqSize / 2}
                r={radius}
                strokeWidth={`${strokeWidth}px`} />
              <circle
                className="circle-progress"
                cx={sqSize / 2}
                cy={sqSize / 2}
                r={radius}
                strokeWidth={`${strokeWidth}`}
                // Start progress marker at 12 O'Clock
                transform={`rotate(90 ${sqSize / 2} ${sqSize / 2})`}
                style={{
                  strokeDasharray: dashArray,
                  strokeDashoffset: dashOffset
                }} />
              <text
                className="circle-text"
                x="50%"
                y="50%"
                dy=".3em"
                textAnchor="middle"
                // style={{fontSize : "2.3rem"}}
                >
                {/* Score rounding up only if decimals exist */}
                {`${score % 1 != 0? score.toFixed(2): score}%`}
              </text>
            </svg>

            {/* <p className='reportDetails'>You have answered <span style={{ fontWeight: '600' }}>{correct}</span> out of <span style={{ fontWeight: '600' }}>{total}</span> questions correctly in <span style={{ fontWeight: '600' }}>{timeTaken}</span></p> */}
            {sections && sections.length != 0 ? <div className='reportDetails'>You have answered:
              {sections.map((sec) => {
              return <div style={{ marginLeft: '20px' }}>
                In {sec.name} ( {sec.marks} marks/question)- <span style={{ fontWeight: '600' }}>{sec.correct_answered_count}</span> out of <span style={{ fontWeight: '600' }}>{sec.total_questions_count}</span> questions correctly in <span style={{ fontWeight: '600' }}>{this.getTime(sec.total_time)}</span>
              </div>

            })}
            </div> :
              <p className='reportDetails'>You have answered <span style={{ fontWeight: '600' }}>{correct}</span> out of <span style={{ fontWeight: '600' }}>{total}</span> questions correctly in <span style={{ fontWeight: '600' }}>{this.getTime(time_taken)}</span></p>
            }
          </PerformanceReport>
        </div>

        <div className='questions'>
          <StyledHeadings >QUESTION WISE ANALYSIS</StyledHeadings>
          <SecondaryHeading>Know what have you answered wrong</SecondaryHeading>
          {sections && sections.length != 0 ? sections.map((sec) => {
            return <div style={{}}>
              <div style={{ textAlign: 'center', fontSize: '16px', fontWeight: '600' }}>{sec.name}</div>
              <QuestionsOverview gridSize={(windowSize - 40) / 5}>
                {sections_dict[sec.id]['question_indexes'] && sections_dict[sec.id]['question_indexes'].length != 0 && sections_dict[sec.id]['question_indexes'].map((id, i) => {
                  let is_correct = questions[id].correctly_answered === 1 ? true : false;
                  return <Hexagon
                    key={id}
                    center
                  // green={is_correct}
                  // red={!is_correct}
                  // onClick={() => this.props.viewQuestion(i)}
                  >
                    <Link to={`/testResults/${this.props.tid}/${id}`}>
                      <Hex />
                      <span style={{ fontSize: '20px', fontWeight: '600', color: is_correct ? 'green' : 'red' }}>{id + 1}</span>
                    </Link>
                  </Hexagon>
                })}
              </QuestionsOverview>
            </div>
          }) :
            <QuestionsOverview gridSize={(windowSize - 40) / 5}>
              {questions.map(({ id }, i) => {
                let is_correct = questions[i].correctly_answered === 1 ? true : false
                return <Hexagon
                  key={id}
                  center
                // green={is_correct}
                // red={!is_correct}
                // onClick={() => this.props.viewQuestion(i)}
                >
                  <Link to={`/testResults/${this.props.tid}/${i}`}>
                    <Hex />
                    <span style={{ fontSize: '20px', fontWeight: '600', color: is_correct ? 'green' : 'red' }}>{i + 1}</span>
                  </Link>
                </Hexagon>
              })}
            </QuestionsOverview>
          }

        </div>
        <div className='questionAnalysisGraph' style={{ WebkitOverflowScrolling: 'touch' }}>
          <div className='graphHeading'>
            <SecondaryHeading >Check the overall class performance</SecondaryHeading>
          </div>
          <div className='chartDiv' style={{ WebkitOverflowScrolling: 'auto', width: chartWidth }}>
            <div id='ct-chart'></div>
          </div>
        </div>
        <style jsx='true' scoped>{`
          .confettiDiv{
            background: url('/images/confetti.svg');
            background-size: cover;
            background-repeat: no-repeat;
            padding: 12px 0;
          }
          .wronganswerconfetti{
            background: url('/images/wronganswerconfetti.svg');
            background-size: contain;
            background-repeat: no-repeat;
            width: 100%;
            margin: auto;
            background-position: center;
            height: 70px;
            margin-bottom: 13px;
            margin-top: -14px;
          }
          .chartDiv{
            padding: 10px;
            position: relative;
            margin: auto;
            margin-top: 50px;
            overflow: auto; 
            height: 100%;
            white-space: nowrap;
            border-radius: 5px;
            overflow-x: auto;
          }
          .graphHeading{
            position: absolute;
            width: 95%;
            overflow-x: hidden;
            overflow-y: scroll;
          }
          .questionAnalysisGraph{
            margin: 10px;
            overflow: auto;
            background-color: white;
            -webkit-overflow-scrolling: touch;
          }
          .boxes{
            margin: auto;
            text-align: center;
            color: white;
            margin-bottom: 20px;
          }
          .list{
            list-style: none;
            padding: 0;
          }
          .listHeading{
            font-size: 30px;
            font-weight: 600;
            padding-top: 12px;
          }
          .listValue{
            font-size: 12px;
            font-weight: 600;
          }
          .box{
            margin-right: 5px;
            padding: 0px 10px;
            width: ${boxWidth}px;
            border-radius: 10px;
          }
          .correct{
            background-color: #3F51B5;
            background-image: linear-gradient(to right, #3F51B5, #8b9bf7);
          }
          .incorrect{
            margin-left: 5px;
            background-color: #673AB7;
            background-image: linear-gradient(to right, #673AB7, #ac8be6);
          } 
          .unanswered{
            padding: 0px 0px;
            margin-left: 5px;
            margin-right: 0;
            background-color: #bbb;
            background-image: linear-gradient(to right, #636363, #d0cdcd);
          }
          .reportDetails{
            text-align: left;
            font-size: 16px;
            margin-left: 12px;
            padding-top: 20px;
          }
          .questions{
            margin: 10px;
            margin-top: 20px;
            padding: 20px 5px 20px 5px;
            border-radius: 5px;
          }
          .rankDiv{
            width: 25%;
            margin: auto;
            margin-top: 8px;
            display: flex;
            flex-direction: row;
          }
          .rank{
            font-size: 20px;
            line-height:1;
            font-weight: 600;
            display: flex;
            flex-direction: column; 
            margin-left: -24px;
            margin-top: -1px;
          }
          .rankValue{
            margin-left: 5px;
          }
          .rankText{
            font-size: 10px;
            font-weight: 500;
          }
          .circle-background,
          .circle-progress {
            fill: none;
          }

          .circle-background {
            stroke: #e6e6e6;
          }

          .circle-progress {
            // stroke: linear-gradient(#3F51B5, violet); 
            stroke: url(#myGradient);
            stroke-linecap: round;
            stroke-linejoin: round;
          }

          .circle-text {
            font-size: 1.7em;
            font-weight: 600;
            fill: #3F51B5;
          }
          #ct-chart{
            stroke-dasharray: none;
            background-color: white;
            font-family: sans-serif;
        }
        #ct-chart .ct-grid {
            stroke-dasharray: none;
          }
          .ct-grid {
            stroke: rgba(23, 2, 2, 0.94);
            stroke-width: 1.5px;
          }
        .ct-series-a .ct-bar {
          /* Colour of your bars */
          stroke:  #216381;
          stroke-width: 8;
          
        }
        .ct-chart-bar .ct-label{
          color: black;
          font-size: 10px;
          text-align: center;
        }
        .ct-axis-title {
            //  color: #FFFFFF !important;
            font-size:12px;
              font-family: sans-serif;
              // font-weight: 200; 
            }
        `}

        </style>
      </div>
    )
  }
}

export default TestSummary;